//  亚克力 acrylic  灰板 Hardcover  盒子 boxProducts    信封  Letterpress   待定 Vows

// 亚克力
let acrylicList = [
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_one_1.jpg"),
    desc: "Custom Colors Handmade Envelopes with Velvet Liner, Elegant Envelopes Velvet Liner, Luxury Invitation Envelope, Card Envelopes",
    detail_desc: "Elegant Nude Handmade Envelopes with Velvet Liner, Affordable Elegant Envelopes, Velvet Liner, Luxury Invitation Envelope, Card Envelopes, Bespoke Custom Wedding Invitation Envelopes Colors VelvetEnvelopes are 250gsm, heavyweight paper premium quality.",
    detail_descItem: [
      "Size & Color can be customized, for the back of the envelope, you can choose to print your return address, and your wedding monorgram on front",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_9.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_one_10.jpg"),
      },
    ],
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_two_6.jpg"),
    desc: "Luxury Arch Acrylic Wedding Invitation with Elegant TerracottaVelvet Pocket + Modern velvet liners envbelope",
    detail_desc: "Perfect for elegant wedding themes and intimate garden affairs or events with outdoor settings, this invitation is impressive and breathtaking. The wedding invite offers a versatile style with its clear 2mm acrylic and luxury foiling printing as well as custom offerings. While created as a modern wedding invitation the design was inspired by fairy tale weddings and old school romance.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logol",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed"
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_9.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_10.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_11.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_12.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_two_5.jpg"),
      },
    ],
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_three_1.jpg"),
    desc: "Luxury Arch shape green Acrylic Wedding Invitation with Creative Green Velvet Pocket + Modern velvet liners envbelope",
    detail_desc: "Perfect for elegant wedding themes and intimate garden affairs or events with outdoor settings, this invitation is impressive and breathtaking. The wedding invite offers a versatile style with its clear 2mm acrylic and luxury foiling printing as well as custom offerings. While created as a modern wedding invitation the design was inspired by fairy tale weddings and old school romance.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_three_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_three_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_three_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_three_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_three_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_three_6.jpg"),
      },
    ],
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_four_1.jpg"),
    desc: "Luxury Arch shape green Acrylic Wedding Invitation with Classical Burgundy Velvet Pocket + Modern velvet liners envbelope",
    detail_desc: "Perfect for elegant wedding themes and intimate garden affairs or events with outdoor settings, this invitation is impressive and breathtaking. The wedding invite offers a versatile style with its clear 2mm acrylic and luxury foiling printing as well as custom offerings. While created as a modern wedding invitation the design was inspired by fairy tale weddings and old school romance.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_four_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_four_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_four_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_four_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_four_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_four_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_four_7.jpg"),
      },
    ],
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_five_4.jpg"),
    desc: "Simple Design Frosted Acrylic with Blind Embossed Bride & Groom Name on Black Envelope",
    detail_desc: "Technology brings about amazing print finishes for wedding invitations including trendy acrylic invites. This frosted acrylic features Black Ink Printing giving the already luxurious acrylic a more sophisticated look. The option to real Gold Foiling to make classial layout design.What's more, the envelope with elegent embossed design for couples name  and slit for RSVP & wishing well cards",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_10.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_11.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_12.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_9.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_five_13.jpg"),
      },
    ],
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_six_3.jpg"),
    desc: "Simple Design Frosted Acrylic with Blind Embossed Bride & Groom Name on Navy Blue Envelope",
    detail_desc: "Technology brings about amazing print finishes for wedding invitations including trendy acrylic invites. This frosted acrylic features Black Ink Printing giving the already luxurious acrylic a more sophisticated look. The option to real Gold Foiling to make classial layout design.What's more, the envelope with elegent embossed design for couples name  and slit for RSVP & wishing well cards",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_six_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_six_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_six_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_six_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_six_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_six_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_six_7.jpg"),
      },
    ],
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_seven_3.jpg"),
    desc: "creative Silver Foiling Frosted Acrylic with Blind Embossed Bride & Groom Name on Navy Blue Envelope",
    detail_desc: "Technology brings about amazing print finishes for wedding invitations including trendy acrylic invites. This frosted acrylic features Creative Silver Foiling Printing giving the already luxurious acrylic a more sophisticated look. The option to real Gold Foiling to make classial layout design.What's more, the envelope with elegent embossed design for couples name  and slit for RSVP & wishing well cards",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_seven_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_seven_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_seven_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_seven_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_seven_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_seven_6.jpg"),
      },
    ]
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_eight_3.jpg"),
    desc: "creative Silver Foiling Clear Acrylic with Blind Embossed Bride & Groom Name on Navy Blue Envelope",
    detail_desc: "Technology brings about amazing print finishes for wedding invitations including trendy acrylic invites. This frosted acrylic features Creative Silver Foiling Printing giving the already luxurious acrylic a more sophisticated look. The option to real Gold Foiling to make classial layout design.What's more, the envelope with elegent embossed design for couples name  and slit for RSVP & wishing well cards",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_eight_8.jpg"),
      },
    ]
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_nine_6.jpg"),
    desc: "creative Silver Foiling Frosted Acrylic with Blind Embossed Bride & Groom Name on Navy Blue Envelope",
    detail_desc: "Technology brings about amazing print finishes for wedding invitations including trendy acrylic invites. This frosted acrylic features Creative Silver Foiling Printing giving the already luxurious acrylic a more sophisticated look. The option to real Gold Foiling to make classial layout design.What's more, the envelope with elegent embossed design for couples name  and slit for RSVP & wishing well cards",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_nine_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_nine_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_nine_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_nine_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_nine_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_nine_6.jpg"),
      },
    ]
  },
  {
    type: "1",
    imgUrl: require("@/assets/img/acrylic/pro_ten_3.jpg"),
    desc: "Creative Die Cut Shape Clear Acrylic Wedding Invitation with Luxury Gold Foiling Edge Envelope ",
    detail_desc: "Perfect for elegant wedding themes and intimate garden affairs or events with outdoor settings, this invitation is impressive and breathtaking. The wedding invite offers a versatile style with its clear 2mm acrylic and luxury foiling printing as well as custom offerings. While created as a modern wedding invitation the design was inspired by fairy tale weddings and old school romance.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc arch shape velvet packet for invitation card",
      "1pc matched size velvet liner envelope for whole set invitation with customized logol",
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/acrylic/pro_ten_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_ten_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_ten_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_ten_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_ten_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_ten_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/acrylic/pro_ten_7.jpg"),
      },
    ]
  },
]
// 灰板
let Hardcover = [
  {
    type: "2",
    imgUrl: require("@/assets/img/Hardcover/pro_one.jpg"),
    desc: "xtravagan hardcover pocket invitation with blind & gold foiling monogram",
    detail_desc: "Featuring a hardcover board wrapped in luxurious textured ivory then hot foil stamped with a crest and your names in real gold foil on the front, your guests will be mesmerized by the regal appeal at a first glance. When opened, a premium heavyweight cotton invitation bonded to the cover will present your custom intricate crest imprinted in blind embossing wedding details foil-stamped in gold along with a border to frame the artwork.",
    detail_descItem: [
      "1 main hardcover with blind debossing/foil logo(color & logo can be customized)",
      "1 customized inser card with gold emboosing name and text",
      "3 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_one_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_one_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_one_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_one_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_one_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_one_6.jpg"),
      },
    ],
  },
  {
    type: "2",
    imgUrl: require("@/assets/img/Hardcover/pro_two.jpg"),
    desc: "Luxury Brush Pink Wedding Invitations with gold foiling acrylic",
    detail_desc: "Luxury pink wedding invitations, presented in the form of folio captivate with their sumptuous, dense velvet cover foil-pressed with a wedding monogram. The invitation wording is foil-pressed on the acrylic/cardboard on the right side of the folio.If you wish to provide your guests with additional information, such as directions to the venue/church, local accommodations, etc., you can choose additional inserts assembled in the shaped velvet pocket. Alternatively, all the details could be included in one velvet mini-book with multiple pages inside. The invitation suite is complemented with a dense envelope. This hardcover invitation comes in a selection of colors and can be ordered in a custom size.",
    detail_descItem: [
      "1 main hardcover with blind debossing/foil logo(color & logo can be customized)",
      "1 customized design acrylic card with foiling name and text",
      "2 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted"
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_two_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_two_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_two_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_two_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_two_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_two_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_two_7.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_three.jpg"),
    desc: "Navy Blue Hardcover Folio with Gold Silver Acrylic Invitation",
    detail_desc: "A beautiful navy blue folio with an oversized silver mirror acrylic monogram invitation. Inside, the invitation is die cut made of acrylic and printed in white foiling print. The cardstock envelope has the monogram printed in gold foil stamp giving the final product a wow factor. The outer envelope is made of navy blue cardstock and the addresses are printed in digital silver foil",
    detail_descItem: [
      "1 main hardcover with silver/gold foiling logo tag on front(color & logo can be customized)",
      "1 customized design acrylic card with foiling name and text",
      "2 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted"
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_three_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_three_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_three_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_three_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_three_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_three_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_four.jpg"),
    desc: "Lush Textured Ivory Hardcover Booklet Wedding Invitation with Pocket for RSVP Card",
    detail_desc: "Extravagant is the best word to describe this captivating and impressive hardcover pocket invitation. It is a favourite among our brides and the book-style design is a rising trend in the wedding invitations world. Featuring a hardcover board wrapped in luxurious textured black then hot foil stamped with a crest and your names in real gold foil on the front, your guests will be mesmerized by the regal appeal at a first glance.When opened, a premium heavyweight cotton invitation bonded to the cover will present your custom intricate crest imprinted in blind letterpress and your wedding details foil-stamped in gold along with a border to frame the artwork. The cotton stock used is the perfect canvas for the letterpress and foil stamping finishes to create a more pressed effect and a textured appeal. ",
    detail_descItem: [
      "1 main hardcover with blind debossing/foil logo(color & logo can be customized)",
      "1 customized insert card with gold emboosing name and text",
      "2 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted"
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_four_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_four_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_four_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_four_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_four_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_four_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_four_7.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_five.jpg"),
    desc: "Rose Gold Color Hardcover Folio with  Clear Acrylic Invitation and Luxury Buckle",
    detail_desc: "A beautiful rose gold color pearlescent cardstock folio with overside clear acrylic invitation with gold foiling details. The rose gold folio has a matching wild rose color ribbon and rose gold color pearl buckle whicg for closing folio and make whole set invitation unique and eyecatching. The invitation also come with matching gold foil details on the outer envelope and cards.",
    detail_descItem: [
      "1 main hardcover with pearl ribbon buckle on front(color & logo can be customized)",
      "1 customized design clear acrylic card with foiling name and text",
      "2 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_9.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_five_10.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_six.jpg"),
    desc: "Elegant Pink Velvet Folio Hardcover Invitation with Gold Mirror Acrylic Rose Tag",
    detail_desc: "A beautiful pink suede folio invitation complete with a custom gold foiling design liner, and a gold acrylic Rose detail monorgram on the outside of the folio. Invitation is ivory card stock with gold foil details. ",
    detail_descItem: [
      "1 main hardcover with good mirror acrylic tag on front(color & logo can be customized)",
      "1 customized design pearlescent cardstock with foiling name and text",
      "2 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_six_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_six_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_six_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_six_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_six_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_six_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_seven.jpg"),
    desc: "Luxury Sage Green Velvet Folio Wedding Invitations with Gray Acrylic Card",
    detail_desc: "These velvet FOLIO invitations feature an elegant blind debossing wedding monogram on the front part of the cover. The invitation wording is foil-pressed on the gray acrylic on the right side of the folio.When opened, a premium gray acrylic invitation to the cover will present your custom intricate crest imprinted in white foiling wedding details along with a border to frame the artwork.",
    detail_descItem: [
      "1 main hardcover with blind debossing monogram on front(color & logo can be customized)",
      "1 customized design gray acrylic card with white color foiling name and text",
      "2 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_seven_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_seven_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_seven_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_seven_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_seven_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_seven_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_eight.jpg"),
    desc: "Luxury Sage Green Velvet Folio Wedding Invitations with clear Acrylic Card",
    detail_desc: "These velvet FOLIO invitations feature an elegant gold foiling wedding monogram on the front part of the cover. The invitation wording is foil-pressed on the gray acrylic on the right side of the folio.When opened, a premium gray acrylic invitation to the cover will present your custom intricate crest imprinted in white foiling wedding details along with a border to frame the artwork.",
    detail_descItem: [
      "1 main hardcover with gold foiling monogram on front(color & logo can be customized)",
      "1 customized design gray acrylic card with white color foiling name and text",
      "2 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_eight_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_eight_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_eight_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_eight_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_eight_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_eight_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_night.jpg"),
    desc: "Off White Velvet Folio Wedding Invitations with Tracing Paper Wedding Program",
    detail_desc: "This regal looking hardcover velvet folio features an elegant embossed gold monogram on the front part of the cover.When opened, a premium tracing paper with wedding program will be showed first, after thatm you will see the wedding details which is including gold foiling debossing name and gold frame decoration",
    detail_descItem: [
      "1 main velvet hardcover with gold foiling monogram on front",
      "1 customized tracing paper with gold foiling wedding program",
      "1 customized design  pearlescent cardstock with gold foiling embossing name and printing details",
      "3 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_night_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_night_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_night_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_night_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_night_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_night_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_night_7.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_ten_1.jpg"),
    desc: "Arched Hardcover Invitation with Luxurious Textured Suede with Gold Foil and Debossing Edge",
    detail_desc: "Creative Aech shape hardcover folio with gold foiling name and blind debossing frame on the font which is Classical and really elegant,After opening, the right side lis the wedding details with name and blind debossing monorgram and arch frame decoration, on the left side, there is blind debossing wedding church/hotel on the top and a pocket for small card for RSVP / wishing well /QR code card ",
    detail_descItem: [
      "1 main arch shape velvet hardcover with gold foiling monogram anf blind debossing edege on front",
      "1 customized design cotton paper with gold foiling name and blind debossing adge & monorgram on right side",
      "1 customized design cotton paper with blind debossing wedding church/hotel on the top and a pocket on left side",
      "3 small cards with gold foiling can be into pocket",
      "3D envelope for whole set invitation with customized logol",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_ten_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_ten_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_ten_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_ten_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_ten_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_ten_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_one_1.jpg"),
    desc: "Gatefold Luxury Hardcover Invitation |hardcover suede invite | Party Invitation | Quinceanera Invitation Baby Blue | Dusty Blue Wedding Invitation",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and transparent Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design ",
      "1pc velvet gatefold with pockets inside",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_one_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_one_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_one_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_one_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_one_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_one_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_two_1.jpg"),
    desc: "Gatefold Luxury Hardcover Invitation |hardcover suede invite | Party Invitation | Luxury Black Velvet Invitation | Acrylic Wedding Invitation",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and transparent Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_two_8.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_three_1.jpg"),
    desc: "Velvet Emerald Green and Gold Foil Trifold Acrylic | Modern Gold Acrylic Wedding Invitation | Acrylic Tri Fold Wedding Invitation Suites",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and transparent Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_5.jpg"),   
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_three_9.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_four_1.jpg"),
    desc: "Silver Trifold Velvet Wedding Invitation | Custom Mirror Acrylic Bundle | Customize Silver Foil Monogram Crest | Invitations Set",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and transparent Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_5.jpg"),   
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_four_8.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_five_1.jpg"),
    desc: "Luxurious Gold Pocket Fold Invitation | Custom Wedding Invites Velvet Emerald | Gold Mirror Acrylic | Monogram Cross | Panel Pocket Invite",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and High-end Gold Mirror Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted/silver/gold mirror acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_five_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_five_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_five_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_five_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_five_5.jpg"),   
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_five_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_six_1.jpg"),
    desc: "Wedding Invitation Suede | Luxury Forest Velvet Envelope and Elegant Acrylic Invitation | Green tassel | Trifold Booklet Invitation | Gold Mirror Acrylic Tag",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and High-end Gold Mirror Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside and  Creative gold mirror monorgram tag & Tissue",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted/silver/gold mirror acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_six_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_six_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_six_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_six_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_six_5.jpg"),     
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_six_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_seven_1.jpg"),
    desc: "Baby Pink Velvet Booklet Wedding Invitation | Minimalist Wedding Invitation Stationery | Quinceanera Graduation Invitation | Acrylic Card Invitation",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and High-end Gold Mirror Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside and  Creative monorgram tag",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted/silver/gold mirror acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_seven_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_seven_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_seven_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_seven_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_seven_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_seven_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_eight_1.jpg"),
    desc: "Luxury Boxed Wedding Invitation Pocket Envelope | Gate Folder Invitation | Acrylic | Burgundy Velvet | Classic Invitation with Gold Foil Crest | Tri-fold Suede Hardcover Invitation",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and High-end Gold Mirror Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside and  Creative monorgram tag",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted/silver/gold mirror acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_eight_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_eight_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_eight_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_eight_4.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_night_1.jpg"),
    desc: "Trifold Wedding Invitation Pocket Set | Booklet Invitation | Custom Invitations | Red Velvet | Gold Foil Crest | Creative Initial Monogram tag",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and High-end Gold Mirror Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside and  Creative monorgram tag",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted/silver/gold mirror acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_night_9.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_17.jpg"),
    desc: "Velvet Acrylic Wedding Invitation | Gold Foil Crest | Custom Invitation Booklet | Trifold Invite Set Card | Pink Luxury Wedding Invitations | Gold Mirror Initial Tag",
    detail_desc: "Luxury hand-made hardcover invitation folio with pockets and High-end Gold Mirror Acrylic in gate fold style. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc velvet gatefold with pockets inside and Gold Mrror Acrylic Initial Tag",
      "1pc matched size velvet liner envelope for whole set invitation with customized logo",
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted/silver/gold mirror acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_11.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_12.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_13.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_14.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_15.jpg"), 
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_16.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_17.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_18.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/hc_pro_ten_19.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_thirteen_9.jpg"),
    desc: "Creative Gatefold Arch Shape Suede Wedding Invitation Signature Gardcover Velet  Invitation with Blind Embossed Initials Tag on Front",
    detail_desc: "A Touch of Velvet, a Promise in Silver – The Cover Bears an Embossed Logo, a Quiet Signature of Elegance; Within, Your Names Shine in Foil Beside a Custom Logo, Where Love Takes Shape in Every Detail. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "A Velvet Embrace, Sealed in Silver – Your Names, Your Story, Your Invitation",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_5.jpg"), 
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_9.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_10.jpg"),  
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_11.jpg"),  
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_thirteen_12.jpg"),  
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Hardcover/pro_fourteen_5.jpg"),
    desc: "Thick Black Velvet Cover Love Wedding Invitation Arch Shape Custom Design Handmade Paper A5 Size Book Fold Invitation Set",
    detail_desc: "Handcrafted Velvet Wedding Invitation – Personalized with White‑Printed Names, Elegant Blind embossed Edges, and a Custom Couple with Pet Logo. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "Clean lines, honest words,and the two names that matter most. No ornament needed—their love is the statement.",
    ],
    detail_descItemTwo: [
      " Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!"
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_5.jpg"), 
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_9.jpg"),  
      },
      {
        imgUrl: require("@/assets/img/Hardcover/pro_fourteen_10.jpg"),  
      },
    ],
  },
];

// 反转整个Hardcover数组，使元素按倒序排列
Hardcover.reverse();

// 盒子
let boxProducts = [
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/pro_one.jpg"),
    desc: "Luxury suede/velvet box with customized gold mirror acrylic card invitation",
    detail_desc:
      "This invitation is very luxurious which is made by hardcover+high quality suede with gold foiling and creative acrylic which is really elegant and will make you day",
    detail_descItem: [
      "1 main suede box foil logo(color & logo can be customized)",
      "1 customized shape acrylic with foil/printing",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/pro_detail_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_detail_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_detail_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_detail_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_detail_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_detail_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/pro_two.jpg"),
    desc: "Dark green suede box invitation gold foil clear acrylic wedding invitation card",
    detail_desc:
      "This invitation is very luxurious which is made by hardcover+high quality suede with gold foiling and creative acrylic which is really elegant and will make you day",
    detail_descItem: [
      "1 main suede box foil logo(color & logo can be customized)",
      "1 customized shape acrylic with foil/printing",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/pro_two_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_two_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_two_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_two_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_two_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_two_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/pro_three.jpg"),
    desc: "Baby pink velvet hardcover box with creative shape acrylic invitation card",
    detail_desc:
      "This invitation is very luxurious which is made by hardcover+high quality suede with gold foiling and creative acrylic which is really elegant and will make you day",
    detail_descItem: [
      "1 main suede box foil logo(color & logo can be customized)",
      "1 customized shape acrylic with foil/printing",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/pro_three_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_three_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_three_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_three_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_three_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_three_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/pro_four.jpg"),
    desc: "Creative shape cleae acrylic invitations with ivory suede foiling logo box ",
    detail_desc:
      "This invitation is very luxurious which is made by hardcover+high quality suede with gold foiling and creative acrylic which is really elegant and will make you day",
    detail_descItem: [
      "1 main suede box foil logo(color & logo can be customized)",
      "1 customized shape acrylic with foil/printing",
      "Any additional cards are accepted",
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/pro_four_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_four_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_four_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_four_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_four_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/pro_four_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/box_pro_one_1.jpg"),
    desc: "Wedding Purple Velvet Invitation Box Clear Acrylic Invitations Luxury invitation | Boxed Invitation | Gold Custom Logo Monogram",
    detail_desc:
      "Luxury hand-made Suede Boxed invitation folio with Ribbon and transparent Acrylic and Tissue inside. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc Soft-touch suede handmade box with ribbon and tissue",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_one_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_one_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_one_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_one_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_one_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_one_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/box_pro_two_1.jpg"),
    desc: "Hot Pink Boxed Wedding Invitation set ,3D Golden Plexi Wedding Invitation Suite Luxury Box, Elegant Boho Velvet Wedding Cards, Bespoke Clear Acrylic Invites",
    detail_desc:
      "Luxury hand-made Suede Boxed invitation folio with Ribbon and transparent Acrylic and Tissue inside. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm acrylic main card with customized design",
      "1pc Hot Pink suede handmade box with ribbon and tissue",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_two_8.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/box_pro_three_1.jpg"),
    desc: "Loyal Navy BlueWedding Invitation set , Golden Plexi Wedding Invitation Suite Luxury Box, Elegant Boho Velvet Wedding Cards, Bespoke Clear Acrylic Invites",
    detail_desc:
      "Luxury hand-made Suede Boxed invitation folio with Ribbon and transparent Acrylic and Tissue inside. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc Navy Blue suede handmade box with ribbon and tissue",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_three_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_three_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_three_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_three_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_three_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_three_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/box_pro_four_1.jpg"),
    desc: "Ivory Velvet Gold Wedding Invitations Pocket, Luxury Wedding Invitation Box with Tissue and Ribbon,Elegant Gold Wedding Cards, Glam Invite | Wedding Station",
    detail_desc:
      "Luxury hand-made Suede Boxed invitation folio with Ribbon and transparent Acrylic and Tissue inside. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm gold mirror acrylic main card with customized design",
      "1pc Ivory/Nude suede handmade box with ribbon and tissue",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_four_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_four_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_four_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_four_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_four_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_four_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/box_pro_five_1.jpg"),
    desc: "Luxury Green Velvet Wedding Invitation Box Suede | Acrylic Wedding Invitations in Box and Luxury Tassel | Custom Wedding Monogram",
    detail_desc:
      "Luxury hand-made Suede Boxed invitation folio with Ribbon and transparent Acrylic and Tissue inside. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm clear acrylic main card with customized design",
      "1pc Dark Green suede handmade box with ribbon and tissue",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_five_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_five_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_five_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_five_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_five_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_five_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/box_pro_six_1.jpg"),
    desc: "Black Luxury Wedding Invitation Box, Custom Logo or Wedding Monogram, Illustration Pressed Foil, Acrylic Invitation, Hand Made Tassel",
    detail_desc:
      "Luxury hand-made Suede Boxed invitation folio with Ribbon and transparent Acrylic and Tissue inside. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm clear acrylic main card with customized design",
      "1pc Luxury Black suede handmade box with ribbon and tissue",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_six_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_six_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_six_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_six_4.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/mainProduct/box_pro_seven_1.jpg"),
    desc: "Creative Black Velvet Box, Wedding Invitation With Custom Acrylic, Wedding Invitations Box, Boxed Invite Bundle, Gold Monogram with RSVP card",
    detail_desc:
      "Luxury hand-made Suede Boxed invitation folio with Ribbon and transparent Acrylic and Tissue inside. This elegant invite comes with custom foiling initial monogram on front. The soft feel of velvet and elegant monogram makes this invite truly elegant.",
    detail_descItem: [
      "1pc 2mm clear acrylic main card with customized design",
      "1pc Luxury Black suede handmade box with ribbon and tissue",
    ],
    detail_descItemTwo: [
      "Additional card can be RSVP card, Thank you cards, save the dates, table numbers etc; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_seven_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_seven_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_seven_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_seven_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_seven_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/mainProduct/box_pro_seven_6.jpg"),
      },
    ],
  },
];

// 信封
let Letterpress = [
  {
    type: "3",
    imgUrl: require("@/assets/img/Letterpress/pro_one_4.jpg"),
    desc: "Classical Wedding Invitation Black Cardstock with White & Gold Foiling Name, Elegant Design Envelope with Slip for RSVP Card",
    detail_desc:
      "Such as this black white and gold wedding invitation card  with your initials in luxurious real gold foil along with your names. The hot foil stamping in exquisite gold on our signature ivory or brighter white cotton stock offers a delightful pressed effect that works flawlessly with the classic black ink printed text to breaks up the bling.",
    detail_descItem: [
      "1pc 500g cardstock invitation with white foiling writing and luxury gold foiling name",
      "1pc 250g cardstock RSVP card ",
      "1pc matched size envelope with slip for RSVP card and gold foiling initial on front "
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Letterpress/pro_one_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_one_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_one_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_one_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_one_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_one_6.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Letterpress/pro_two_4.jpg"),
    desc: "Arch Shape Wedding Invitation, 500g Cotton Paper Invitation with Blind Embossed Flowers Edge and Gold Foiling Name, Wedding Invitation Set Envelope with 3D Enbossing ",
    detail_desc:
      "Arch wedding invites with fully customisable embossed names and white ink printing. The luxurious feel of cotton or ivory textured paper which gives this invitation suite a superior edge matching accessory cards, on-the-day signage, and coloured envelopes to complete the look.",
    detail_descItem: [
      "1pc 500g cardstock Arch invitation with flower embossed flowers and gold foiling name ",
      "1pc 500g cardstock RSVP card with gold foiling edge",
      "1pc matched size envelope with slip for RSVP card and gold foiling initial on front"
    ],
    detail_descItemTwo: [
      "Any additional cards are accepted; clear/frosted acrylic is optional; printing&envelope color can be changed Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Letterpress/pro_two_10.jpg"),
      },
    ],
  },
];
let Vows = [
  {
    type: "3",
    imgUrl: require("@/assets/img/Vow/pro_one_1.jpg"),
    desc: "Handmade Luxury Oval menu, Bound by Hand, Framed in Elegance – Oval Pages Embellished with Gold Initial and Red foil flowers ,Each Blessing a Silent Promise, Each Thread a Tender Embrace",
    detail_desc:
      "Every blessing is hand‑stitched into this oval menu—where vintage gold foiling Initialmeets romantic red Flowers,and each foil detail tells a story of timeless love.From the warmth of the hand‑sewn thread to the intricate elegance of the design,it’s more than a menu—it's a keepsake of your first chapter together.Cherish the beauty. Celebrate the beginning.",
    detail_descItem: [
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Vow/pro_one_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_9.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_10.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_11.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_one_12.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Vow/pro_two_1.jpg"),
    desc: "Handmade ivory Wedding Ceremony card, Hand stitched Oval wedding menu card with gold foiling initial,sewn with tenderness, ready to welcome those who matter most.",
    detail_desc:
      "An oval keepsake, cradled in hand-stitched threads.Crafted on rich, textured paper,adorned with your gilded initial—a quiet promise etched in gold,sewn with tenderness,ready to welcome those who matter most.",
    detail_descItem: [
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Vow/pro_two_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_5.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_6.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_7.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_8.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_9.jpg"),  
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_two_10.jpg"),
      },
    ],
  },
  {
    type: "3",
    imgUrl: require("@/assets/img/Vow/pro_three_1.jpg"),
    desc: "Handmade Res/Ivory Wedding Vow card, Hand stitched Oval wedding menu card with gold foiling initial,sewn with tenderness, ready to welcome those who matter most.",
    detail_desc:
      "There is something sacred in the details.The gentle curve of an oval.Paper so textured it feels like a love letter.A single initial brushed in gold—yours, together.And along the edges, thread woven by hand,stitch by stitch, as if time itself paused to make it beautiful.This is not merely a ceremony card.It is the first chapter,held in your guests’ hands before the journey begins.",
    detail_descItem: [
    ],
    detail_descItemTwo: [
      "Minimum Quantity for this product is 50. If an order is placed for below 50 qty the unit price will be higher. Thank you so much for your understanding!",
    ],
    childrens: [
      {
        imgUrl: require("@/assets/img/Vow/pro_three_1.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_three_2.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_three_3.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_three_4.jpg"),
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_three_5.jpg"),  
      },
      {
        imgUrl: require("@/assets/img/Vow/pro_three_6.jpg"),
      },
    ],
  },
];

export function productList(value) {
  if (value == 1) {
    return acrylicList;
  } else if (value == 3) {
    return boxProducts;
  } else if (value == 2) {
    return Hardcover;
  } else if (value == 4) {
    return Letterpress;
  } else if (value == 5) {
    return Vows;
  }
  return acrylicList;
}
